import React from 'react';
import { useTranslation } from 'react-i18next';

import Search from '../form/search';

interface Props {
  handleSearch: (value) => void;
  i18nKey?: string;
  style?: any;
  className?: string;
  value: string;
}

export default function SearchItems({
  handleSearch,
  i18nKey = 'DASHBOARD_SEARCH_ITEM',
  style,
  className,
  value,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Search
      className={className}
      style={style}
      handleSearch={(e): void => handleSearch(e.target.value)}
      inputProps={{
        'aria-label': t(i18nKey),
      }}
      data-testid="search-input"
      placeholder={t(i18nKey)}
      type="button"
      value={value}
    />
  );
}
